module.exports = __webpack_public_path__ + "img/img12.64640dac.png";